/* @flow */

import React from 'react'
import Auth from '../utils/auth';
const auth = new Auth();
import PricingTable from './PricingTable';
import PricingTable2 from '../components/PricingTable2';
import LoginTable from './LoginTable';


const hhsACx = 'clr-blue relative hhs';

type tPROPS = {
    content: Array<Object|string>;
    freeOrNot: String;
  };

class BodyContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        authenticated: false
        };
    }

    login() {
        //const type = {type: 'login'};
        const email2 = {email: ''};
        auth.login(email2);
         this.setState({authenticated: auth.isAuthenticated()},function(){ 
           // this.setState({username: auth.getUserName()})
         });
         this.setState({
          username: auth.getUserName(),
        })
        // this.setState({
        //   authenticated: auth.isAuthenticated(),
        // });
      }

    componentDidMount() {
        if (auth.isAuthenticated()){
                this.setState({
                    authenticated: auth.isAuthenticated()
                });
            }
    }

    render (){

        console.log(this.props.freeOrNot);

        const free = (this.props.freeOrNot === '/processes/frontoffice/Pricing/') || this.props.freeOrNot === '/processes/frontoffice/PreDealChecks/' || this.props.freeOrNot === '/processes/frontoffice/TransactionExecution/' || this.props.freeOrNot === '/processes/operations/confirmations/' || this.props.freeOrNot === '/processes/operations/settlements/' || this.props.freeOrNot === '/processes/finance/accounting/' || this.props.freeOrNot === '/processes/credit_risk/credit_risk_control/' || this.props.freeOrNot === '/processes/market_risk/market_risk_control/'
        || this.props.freeOrNot === '/processes/frontoffice/' || this.props.freeOrNot === '/processes/operations/' || this.props.freeOrNot === '/processes/finance/' || this.props.freeOrNot === '/processes/credit_risk/' || this.props.freeOrNot === '/processes/market_risk/'
        || this.props.freeOrNot === '/concepts/trade_lifecycle_concepts/' || this.props.freeOrNot === '/concepts/risk_management_concepts' || this.props.freeOrNot === '/ftbModules/trade_lifecycle' || this.props.freeOrNot === '/ftbModules/new_entity'|| this.props.freeOrNot === '/ftbModules/'

        
        return(
            <div>

                {/* <span>
                    {this.props.content}
                </span> */}

            {
                this.state.authenticated && (
                <span>
                    {this.props.content}
                </span>
                )
            }    

            {
                !this.state.authenticated && free && (
                <span>
                    {this.props.content}
                </span>
                )
            }    

            {
                !this.state.authenticated && !free && (
                <span>
                    <section className="doc-content">
                        Subscribe now or if you have already subscribed, <a href="#"
                  className={hhsACx}
                  onClick={this.login.bind(this)}
                >
                  sign in
                </a> here.<br/>
                        <table style = {{
                          border: '0px',
                        }}><tr><td>
                        <PricingTable />
                        </td><td>
                        {/* <PricingTable2 /> */}
                        </td>
                        </tr>
                        </table>                                           
                    </section> 
                </span>
                )
            }                
            </div>
        )
    }
}

BodyContent.displayName = 'components/BodyContent'
export default BodyContent



// WEBPACK FOOTER //
// ./src/components/BodyContent.jsx